import { produce } from 'immer';
import { orderBy } from 'lodash';

import { UpdateInternalProducts } from '../../../actions/products/internal/updateInternalProducts';
import { routeToKeyMap } from '../../../service/ProductsHelpers';
import { Product, ProductsState } from '../../../typings/products';

export function updateInternalProducts(state: ProductsState, action: UpdateInternalProducts): ProductsState {
    return produce(state, draft => {
        draft.products = action.products;

        if (action.sortParams) {
            draft.products = orderBy<Product>(
                draft.products,
                [routeToKeyMap[action.sortParams.key]],
                [action.sortParams.direction]
            );
        }

        draft.filtered = [];
        draft.isFiltered = false;
    });
}
